import { useEffect, useState } from "react";

// Retorna um estado de loading que respeita um atraso mínimo quando transiciona de true -> false
export const useMinDelay = (isLoading, minMs = 350) => {
  const [delayedLoading, setDelayedLoading] = useState(isLoading);

  useEffect(() => {
    let timer;
    if (isLoading) {
      setDelayedLoading(true);
    } else {
      timer = setTimeout(() => setDelayedLoading(false), minMs);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isLoading, minMs]);

  return delayedLoading;
};


